import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type DeleteSafetyFunctionDialogProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
}

export function DeleteSafetyFunctionDialog({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}: DeleteSafetyFunctionDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>
            {t('safetyFunctionsPage.deleteDialog.title')}
          </DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          {t('safetyFunctionsPage.deleteDialog.description')}
        </p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            {t('common:actions.cancel')}
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {t('safetyFunctionsPage.deleteDialog.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
